"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = void 0;
const slugify = (string) => {
    return (string
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-') // Replace spaces with -
        // Remove all non-word chars
        .replace(/[^\w\-]+/g, '') // eslint-disable-line no-useless-escape
        // Replace multiple - with single -
        .replace(/\-\-+/g, '-') // eslint-disable-line no-useless-escape
    );
};
exports.slugify = slugify;
//# sourceMappingURL=slugify.js.map